import { z } from 'zod';

const num = () => z.coerce.number();
const numNull = () => z.union([z.coerce.number(), z.null()]);

/* Depth targets (goalpost.store_brand_depth_target via
   stg_supabase_store_brand_depth_target), active rows, with brand manager and merch portfolio. */
export const DepthBreadthTargetsSchema = z.array(
  z.object({
    store: z.string(),
    brand_name: z.string(),
    effective_from: z.string(),
    depth_per_style: numNull(),
    count_of_sizes: numNull(),
    brand_manager: z.string().nullable(),
    merch_portfolio: z.string().nullable(),
  }),
);
export type DepthBreadthTargets = z.infer<typeof DepthBreadthTargetsSchema>;

/* mart_store_brand_depth_daily for one facility and date range. */
export const DepthBreadthDailySchema = z.array(
  z.object({
    date: z.string(),
    facility_name: z.string(),
    brand_name: z.string(),
    hangers: num(),
    styles: num(),
    total_units: num(),
    size_count_sum: num(),
  }),
);
export type DepthBreadthDaily = z.infer<typeof DepthBreadthDailySchema>;

/* Today's live depth rows (mart_latest_warehouse_inventory) for one facility;
   updated_at = latest inventory change in the facility, same on every row. */
export const DepthBreadthLiveSchema = z.array(
  z.object({
    date: z.string(),
    facility_name: z.string(),
    brand_name: z.string(),
    hangers: num(),
    styles: num(),
    total_units: num(),
    size_count_sum: num(),
    updated_at: z.string().nullable(),
  }),
);
export type DepthBreadthLive = z.infer<typeof DepthBreadthLiveSchema>;

export const DepthBreadthBrandOptionsSchema = z.array(z.object({ brand_name: z.string() }));
export type DepthBreadthBrandOptions = z.infer<typeof DepthBreadthBrandOptionsSchema>;
